export { useMenuGroupContextValues_unstable as useMenuGroupContextValues } from '@fluentui/react-menu';
